<template>
<div>
  <vHeader ref="header" :title="title" routerTo="/transport">
    <img class="menu-img" src="@/assets/menu.png" @click="clickMenu"/>
  </vHeader>

  <div class="body" :style="{ height: bodyHeight + 'px' }">
    <vNavigation v-show="showNav"/>
    <router-view class="router-view" @send="send"></router-view>
  </div>
</div>
</template>

<script>
import vNavigation from "@/components/navigation.vue"
import vHeader from "@/components/header.vue"

export default {
  components: {
    vNavigation,
    vHeader
  },

  data() {
    return {
      headerHeight: 0,
      footerHeight: 26,

      firebaseTokenTimer: null,
      showNav: true
    }
  },

  created() {
    this.getFirebaseToken().then(() => {
      if (Object.keys(this.$store.state.store.user).length == 0) {
        this.getUser()
      }
    })
    // 30分毎にトークンを更新
    this.firebaseTokenTimer = window.setInterval(this.getFirebaseToken, 1800000)

    // スマホの場合はメニューを表示しないでおく
    if (window.innerWidth <= 420) {
      this.showNav = false
    }
  },
 
  mounted() {
    this.getHeights()
  },

  beforeRouteUpdate (to, from, next) {
    if (to.meta.isAdminOnly) {
      if (this.$store.state.store.user.auth != 0) {
        firebase.auth().signOut()
      }
    }
    next()
  },

  destroyed() {
    clearInterval(this.firebaseTokenTimer)
  },

  watch: {
    $route () {
      this.$nextTick(() => {
        this.getHeights()
      })
    }
  },

  computed: {
    title() {
      if (this.$route.name == "transport_detail") {
        return this.$route.query.name + "　" + this.$route.meta.title
      } else {
        return this.$route.meta.title
      }
    },

    bodyHeight() {
      return window.innerHeight - (this.headerHeight + this.footerHeight)
    }
  }, 

  methods: {
    clickMenu() {
      this.showNav = !this.showNav
    },

    getFirebaseToken() {
      return new Promise((resolve, reject) => {
        // 通信の待機フラグ
        this.$store.dispatch("wait", true)
        this.$firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            user.getIdToken(/* forceRefresh */ true).then((idToken) => {
              this.$store.dispatch("setToken", idToken).then(() => {
                this.$store.dispatch("wait", false)
                resolve()
              })
            })
          } else {
            alert("認証エラーです。\nログインし直してください。")
            this.$store.dispatch("wait", false)
            this.$router.push({ name: "index" })
            reject()
          }
        })
      })
    },

    getUser() {
      this.$http.get("/user_data").then((res) => {
        this.$store.dispatch("setUser", res.data).then(() => {
          this.$router.go()
        })
      })
    },

    send(func) {
      var elapsedSec = 0
      var id = setInterval(() => {
        elapsedSec++
        // 待機フラグがfalseになるか、5秒を過ぎたら処理実行
        if (this.$store.state.store.wait == false || 10 < elapsedSec) {
          clearInterval(id)
          func()
        }
      }, 500)
    },

    getHeights() {
      this.headerHeight = this.$refs.header.$el.clientHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  overflow: hidden;
}

.menu-img {
  display: none;
}

.router-view {
  display: inline;
  vertical-align: middle;
}

@media screen and (max-width: 420px) {
  .menu-img {
    display: unset;
    margin-right: 5px;
    align-self: center;
  }
}
</style>